import { Toast } from "./components/@UI/Services";

export class ErrorService {
    static process(ex: any) {
        Toast.show(ex.message || ex, "danger");
    }
}